import theme from "lib/theme/theme";
import { SxObjType } from "lib/theme/types/SxObjType.type";

const sxStyles = () => {
  return {
    infoBox: { mb: 2 },

    contentText: {
      color: theme.palette.grey[400],
      typography: theme.typography.body2_regular,
    },
  } satisfies SxObjType;
};
export { sxStyles };
